import ReactDOM from 'react-dom/client';
import React, { Suspense } from 'react';
//
import { useNavigate } from 'react-router-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './i18n';
import reportWebVitals from './reportWebVitals';
import { CircularProgress } from '@material-ui/core';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './keycloak';
import { setUserSession } from './utils/common';
import { handleKeycloakEvent } from 'src/utils/authkeycloak'

// ----------------------------------------------------------------------
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Suspense
    fallback={
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </div>
    }
  >
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={{ onLoad: 'check-sso', silentCheckSsoRedirectUri: `${location.origin}/silent-check-sso.html` }}
      onEvent={(event, error) => handleKeycloakEvent(event, error, keycloak, setUserSession)}
    >
      <App />
    </ReactKeycloakProvider>
  </Suspense>
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
